import React from 'react';

const LineChartSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='333'
      height='197'
      viewBox='0 0 333 197'
      fill='none'
      onClick={onClick}
      className={className}
      {...props}
    >
      <g clipPath='url(#clip0_14621_688189)'>
        <path
          d='M75.3293 127.86C47.9514 144.425 11.4476 130.161 -3.38215 120.958L-92.3604 386.195L1079.76 415.776C1087.17 295.154 1092.42 49.3739 1054.09 31.2313C1006.18 8.55309 982.223 50.9515 973.667 63.7697C965.111 76.5878 936.022 86.4479 912.067 82.5039C888.111 78.5598 836.777 127.86 800.844 139.693C764.91 151.525 715.288 86.4479 693.043 75.6019C670.799 64.7558 651.977 88.42 643.421 86.4479C634.865 84.4759 598.932 22.3572 573.265 23.3432C547.598 24.3293 525.354 82.5039 506.531 75.6019C487.709 68.6998 467.176 120.958 403.864 155.469C340.553 189.979 314.886 24.3293 280.664 16.4412C246.441 8.55313 236.175 43.0635 201.952 75.6019C167.73 108.14 152.33 83.49 142.063 75.6019C131.796 67.7138 109.552 107.154 75.3293 127.86Z'
          fill='url(#paint0_linear_14621_688189)'
          stroke='#09CDAE'
          strokeWidth='4'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M75.3293 127.86C47.9514 144.425 11.4476 130.161 -3.38215 120.958L-92.3604 386.195L1079.76 415.776C1087.17 295.154 1092.42 49.3739 1054.09 31.2313C1006.18 8.55309 982.223 50.9515 973.667 63.7697C965.111 76.5878 936.022 86.4479 912.067 82.5039C888.111 78.5598 836.777 127.86 800.844 139.693C764.91 151.525 715.288 86.4479 693.043 75.6019C670.799 64.7558 651.977 88.42 643.421 86.4479C634.865 84.4759 598.932 22.3572 573.265 23.3432C547.598 24.3293 525.354 82.5039 506.531 75.6019C487.709 68.6998 467.176 120.958 403.864 155.469C340.553 189.979 314.886 24.3293 280.664 16.4412C246.441 8.55313 236.175 43.0635 201.952 75.6019C167.73 108.14 152.33 83.49 142.063 75.6019C131.796 67.7138 109.552 107.154 75.3293 127.86Z'
          stroke='#09CDAE'
          strokeWidth='4'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle
          cx='45'
          cy='134'
          r='9'
          fill='#09CDAE'
          stroke='white'
          strokeWidth='2'
        />
        <circle
          cx='96'
          cy='112'
          r='9'
          fill='#09CDAE'
          stroke='white'
          strokeWidth='2'
        />
        <circle
          cx='137'
          cy='75'
          r='9'
          fill='#09CDAE'
          stroke='white'
          strokeWidth='2'
        />
        <circle
          cx='178'
          cy='91'
          r='9'
          fill='#09CDAE'
          stroke='white'
          strokeWidth='2'
        />
        <circle
          cx='221'
          cy='51'
          r='9'
          fill='#09CDAE'
          stroke='white'
          strokeWidth='2'
        />
        <circle
          cx='271'
          cy='14'
          r='9'
          fill='#09CDAE'
          stroke='white'
          strokeWidth='2'
        />
        <circle
          cx='313'
          cy='59'
          r='9'
          fill='#09CDAE'
          stroke='white'
          strokeWidth='2'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_14621_688189'
          x1='497.976'
          y1='-23.1525'
          x2='496'
          y2='228.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#98FAEA' />
          <stop offset='0.72165' stopColor='#98FAEA' stopOpacity='0' />
        </linearGradient>
        <clipPath id='clip0_14621_688189'>
          <rect width='333' height='197' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LineChartSVG;
